// import { data } from './data/data_insulin'

// export const konkatenoiInsuliiniKoonti = (arr) => {


//     console.log(arr);

//     let palaute = 'palautetta';

//     //pistopaikka = arr[0] eli jos pistopaikka oli väärä
//     if (arr[0] == 0) {
//         palaute += " " + data.pistopaikka.palaute_pistopaikka_ei_ok
//     }
//     //jos pistopaikka oli oikein
//     if (arr[0] == 1) {
//         palaute += " " + data.pistopaikka.palaute_pistopaikka_ok
//     }

//     //pistosyvyys = arr[1] eli jos pistosyvyys oli väärä
//     if (arr[1] == 0) {
//         palaute += " " + data.pistosyvyys.palaute_pistosyvyys_ei_ok
//     }
//     //pistosyvyys oli oikein
//     if (arr[1] == 1) {
//         palaute += " " + data.pistosyvyys.palaute_pistosyvyys_ok
//     }



//     return palaute

// }


export const pisteytys = (arr) => {
    // arr = lukuja 5 kpl, lasketaan keskiarvo ja pyöristetään kokonaislukuun ylöspäin
    console.log(arr);
    return ((arr[0] + arr[1]) / arr.length)

}


export const validateImage = (img) => {
    // välillä 21-38 --> ok
    if (
        img.includes('21.')
        || img.includes('22.')
        || img.includes('23.')
        || img.includes('24.')
        || img.includes('25.')
        || img.includes('26.')
        || img.includes('27.')
        || img.includes('28.')
        || img.includes('29.')
        || img.includes('30.')
        || img.includes('31.')
        || img.includes('32.')
        || img.includes('33.')
        || img.includes('34.')
        || img.includes('35.')
        || img.includes('36.')
        || img.includes('37.')
        || img.includes('38.')
    ) {
        return true
    }
    else return false

}


export const needleIn = (img) => {
    // välillä 21-38 --> ok
    if (
        img.includes('21.')
        || img.includes('22.')
        || img.includes('23.')
        || img.includes('24.')
        || img.includes('25.')
        || img.includes('26.')
        || img.includes('27.')
        || img.includes('28.')
        || img.includes('29.')
        || img.includes('30.')
        || img.includes('31.')
        || img.includes('32.')
        || img.includes('33.')
        || img.includes('34.')
        || img.includes('35.')
        || img.includes('36.')
        || img.includes('37.')
        || img.includes('38.')
    ) {
        return true
    }
    else return false

}
